import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles/global.css' // Import global styles
import './styles/fonts.css'

createApp(App).use(router).mount('#app')
